import { render, staticRenderFns } from "./editStaffNotesModal.vue?vue&type=template&id=2e460a35&"
import script from "./editStaffNotesModal.vue?vue&type=script&lang=js&"
export * from "./editStaffNotesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e460a35')) {
      api.createRecord('2e460a35', component.options)
    } else {
      api.reload('2e460a35', component.options)
    }
    module.hot.accept("./editStaffNotesModal.vue?vue&type=template&id=2e460a35&", function () {
      api.rerender('2e460a35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/appointments/components/editStaffNotesModal.vue"
export default component.exports